<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title>Forgot Password</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form">
                  <v-text-field
                    v-model="email"
                    name="email"
                    label="Your Email"
                    type="email"
                    placeholder="Enter Your Email"
                    required
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>

                  <div class="red--text">{{ error }}</div>
                  <div class="primary--text">
                    {{ message }}
                  </div>
                  <v-btn
                    dark
                    color="teal"
                    class="mr-4"
                    rounded
                    :loading="loading"
                    @click="submit()"
                  >
                    Send Email
                  </v-btn>
                  <v-btn to="/login" sm text> Back to Login </v-btn>
                </form>
              </v-card-text>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import api from "@/api";
import axios from "axios";

export default {
  name: "LoginForm",
  data: () => ({
    valid: true,
    email: "",
    loading: false,
    message: "",
    error: "",
    rules: {
      required: (v) => !!v || "Email is required",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    },
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          // if (!this.email) {
          //   this.message = "";
          //   this.error = "Please Fill Your Email";
          // }
          if (this.email) {
            this.loading = true;
            await axios
              .post("/api/forgetpassword", {email: this.email})
              .then(async (res) => {
                //  console.log(res.data.success);
                if (res.data.success == true) {
                  this.error = "";
                  this.message = "Link Sent , Please Check Your Mail";
                  this.email = "";
                  this.loading = false;
                  await this.$nextTick();
                  this.$refs.form.reset();

                  //  this.$router.push("/login");
                  //    router.push({ name: "/" });
                } else {
                  this.error = "Please Write correct details";
                  this.email = "";
                  this.loading = false;
                  this.message = "";
                }
              });
          }
        } catch (error) {
          this.email = "";
          this.error = "Please Write Correct Details.";
          this.loading = false;
        }
      }
    },
  },
};
</script>